module.exports = __webpack_public_path__ + "media/images/country_flags/bf-85bacdc51d4312801a0cd2faf662dd23.png";